import { Component, OnInit, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { WeldGun } from '../../../../shared/model';
import { ToolTypeDescriptionService, ToolTypeService } from '../../camtl.service';
@Component({
  selector: 'app-weldgun',
  templateUrl: './weldgun.component.html',
  // styleUrls: ['./weldgun.component.scss']
})
export class WeldgunComponent implements OnInit {

  constructor(
    private ToolTypeDescriptionService: ToolTypeDescriptionService,
    private ToolTypeService: ToolTypeService,
    private formBuilder: FormBuilder,
  ) { }

  isNew: boolean = false;
  editDataItem: WeldGun;
  ToolTypeId: any;
  editForm = this.formBuilder.group({
    Id: [],
    Name: [Validators.required],
    Description: [Validators.required],
    ToolTypeId: [Validators.required],
    CreatedDate: [],
    CreatedBy: [],
    IsActive: [Validators.required],
    ModifiedDate: [],
    ModifiedBy: [],
    AdditionalInfo: [Validators.required],
  })



  columns: any[] = [
    {
      field: "Name",
      title: "Name",
    },
    {
      field: "Description",
      title: "Description",
    },
    // {
    //   field: "ToolTypeId",
    //   title: "ToolTypeId",
    // },
    {
      field: 'ToolTypeId',
      title: 'Tool Type',
      template: {
        type: 'filter',
        filter: {
          field: "Description",
          check: "Id",
          readonly: "never",
        },
        pipe: 'nameById',
        dataSource: this.ToolTypeService,
      }
    },
    {
      field: "IsActive",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
    {
      field: "AdditionalInfo",
      title: "Additional Info",

    }
  ]

  handleread = () => {

    var self = this;

    return this.ToolTypeService.read("", true).then(function (toolTypes: any) {
      self.ToolTypeId = toolTypes.Items.filter(function (ToolType) {
        return ToolType.Description === "WeldGun";
      })[0].Id;

      return self.ToolTypeDescriptionService.read("/" + self.ToolTypeId, true).then(function (response: any[]) {

        return response;


      })
    })
  }

  template = {

    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: false,
      width: 65,
    },
    columns: this.columns,
    service: this.ToolTypeDescriptionService,
    read: this.handleread
  }

  formDialog = {
    title: "Kit",
    formControls: [
      {
        type: "text",
        name: "Name",
        title: "Name",
        readonly: "never",

      },
      {
        type: "text",
        name: "Description",
        title: "Description",
      },
      // {
      //   type: "combobox",
      //   name: "ToolTypeId",
      //   title: "Tool Type Id",
      //   textField: 'ToolTypeId',
      //   valueField: 'ToolTypeId',
      //   placeholder: 'Select a ToolTypeId...',
      //   service: this.ToolTypeDescriptionService,

      // },

      {
        type: "boolean",
        name: "IsActive",
        title: "IsActive",
        readonly: "never",
      },
      {
        type: "text",
        name: "AdditionalInfo",
        title: "Additional Info",
      }

    ],
  }


  public ngOnInit(): void {
    this.ToolTypeDescriptionService.query();
  }

  setModelHandler() {
    this.editDataItem = new WeldGun();
    this.editDataItem.ToolTypeId = this.ToolTypeId
    // console.log(this.formDialog)
  }

}